import React, { useState, useEffect, useRef } from "react";
import { useInView } from "react-intersection-observer";
import { motion, useViewportScroll, useTransform } from "framer-motion";
import Hero from "../components/Hero";
import Divider from "../components/Divider";
import OurProductLine from "../components/OurProductLine";
import StickyImage from "../components/StickyImage";
import ProductsSection from "../components/ProductsSection";
import Testimonials from "../components/Testimonials";
import AutoScrollingImages from "../components/AutoScrollingImages";
import RedSection from "../components/About/RedSection";
import ProductDivider from "../components/ProductDivider";
import ComparisonTable from "../components/ComparisonTable";
import ParallaxSection from "../components/ParallaxSection";
import { CONTENT_TYPES } from "../constants/contentTypes";
import './Home.css';
import StickyProductBackground from "../components/StickyProductBackground";
import StickySplitBackground from "../components/StickySplitBackground";
import { fetchProducts } from "../contentful";
import MadeInAmerica from "../components/MadeInAmerica";
console.log('[HomeB2B] Rendering HomeB2B');

const Household = () => {
  console.log('[HomeB2B] Rendering HomeB2B page');
  // InView hooks for key markers
  const { ref: productLineEndInViewRef, inView: productLineEndInView } = useInView({
    threshold: 0,
  });
  const { ref: footerSentinelRef, inView: footerSentinelInView } = useInView({
    threshold: 0.1,
  });

  // Create refs
  const productLineEndElement = useRef(null);
  const setProductLineEndRef = (node) => {
    productLineEndInViewRef(node);
    productLineEndElement.current = node;
  };

  // State for products
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch products
  useEffect(() => {
    const loadProducts = async () => {
      try {
        const fetchedProducts = await fetchProducts(CONTENT_TYPES.HOUSEHOLD);
        setProducts(fetchedProducts);
        setIsLoading(false);
      } catch (error) {
        console.error("Error loading products:", error);
        setIsLoading(false);
      }
    };

    loadProducts();
  }, []);

  // Responsive margin-top for the overlay Our Products section
  const getMarginTop = (width) => {
    if (width >= 2560) return "-100px";    // 4K displays
    else if (width >= 1536) return "-150px"; // Large desktops
    else if (width >= 1280) return "-190px"; // Standard desktops
    else if (width >= 1024) return "-250px"; // Smaller desktops / large tablets
    else if (width >= 768) return "-300px";   // Tablets
    else return "-350px";                     // Mobile devices
  };

  const [sectionMarginTop, setSectionMarginTop] = useState(getMarginTop(window.innerWidth));
  useEffect(() => {
    const handleResize = () => {
      setSectionMarginTop(getMarginTop(window.innerWidth));
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const heroImageSrc = "/images/B2BRRBottlesHeroImage.png";
  console.log('[HomeB2B] Passing heroImageSrc to OurProductLine:', heroImageSrc);

  return (
    <>
      <div className="relative w-full max-w-[100vw] overflow-x-hidden">
        <Hero />

        {/* Product Line Section */}
        <div
          style={{
            position: "relative",
            zIndex: 2,
            boxShadow: "0px 20px 30px rgba(0,0,0,0.3)",
            padding: "0rem",
            marginTop: "0rem"
          }}
        >
          {console.log('[HomeB2B] Rendering OurProductLine with heroImageSrc:', heroImageSrc)}
          <OurProductLine />
          <MadeInAmerica />
        </div>
        
        <StickySplitBackground
          leftImage="/static/media/Family.878a9242862045f9649c.png"
          rightImage="https://images.ctfassets.net/hdznx4p7ef81/4qZzk5uIy0wOYMAQFsuUKc/261d1fbaa8c110973c50185e1f2a909e/RR_Cleaning_Mess_Zoomed_Out.jpg"
          className="my-8 md:my-16"
          showOverlay={productLineEndInView}
        >
          <div className="container mx-auto px-4 py-8 md:py-16">
            <h2 className="text-2xl md:text-3xl font-bold text-center mb-4 md:mb-8">
              Discover Our Range of Household Products
            </h2>
            <p className="text-base md:text-lg text-center max-w-2xl mx-auto">
              From kitchen cleaners to bathroom solutions, we have everything you need to keep your home sparkling clean.
            </p>
          </div>
        </StickySplitBackground>
        
        <div ref={setProductLineEndRef} />

        {/* Sticky Split Background */}
       
        {/* Products Section with Sticky Background */}
        <ProductsSection 
          contentType={CONTENT_TYPES.HOUSEHOLD}
          title="Our Products"
          isProfessional={false}
          showQuoteButton={false}
        />
         <AutoScrollingImages />
        {/* Comparison Table Section */}
        <div style={{ position: 'relative', width: "100%", maxWidth: "100vw" }}>
          <ComparisonTable />
        </div>

        {/* Testimonials Section */}
        {/* <section className="relative w-full max-w-[100vw] text-white py-24 px-6 overflow-hidden" style={{ marginBottom: "6rem" }}>
          <div
            className="absolute inset-0 -z-10 bg-cover bg-center filter blur-sm"
            style={{
              backgroundImage: `url('https://images.ctfassets.net/hdznx4p7ef81/4bmH8LUErm4lVMKisci0EQ/afe5be750a53f06d5c46903aafd010e5/CD_Cleaning_Grease_on_Table.jpg')`,
              backgroundPosition: "center 75%",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              opacity: 0.7,
            }}
          ></div>
          <div className="absolute inset-0 -z-10 bg-white opacity-40"></div>
          
        </section> */}
        
        <Testimonials />

        {/* Additional Content Sections */}
       
        <RedSection />
      </div>

      {/* Footer Sentinel */}
      <div ref={footerSentinelRef} style={{ height: "1px" }}></div>
    </>
  );
};

export default Household; 